import { useCallback, useState } from 'preact/hooks';

export function usePage(initialState: number) {
  const [page, setPage] = useState(initialState);

  return {
    page,
    handleNextPage: useCallback(() => setPage((page) => page + 1), []),
    handlePrevPage: useCallback(() => setPage((page) => page - 1), []),
    handlePage: useCallback((index: number) => setPage(index), []),
  };
}
